import { Component, ChangeDetectionStrategy } from '@angular/core';
import { IconByNameComponent } from './shared/components/icon-by-name.component';

@Component({
  templateUrl: './page-not-found.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IconByNameComponent],
})
export class PageNotFoundComponent {}
